import {GridModel} from '@xh/hoist/cmp/grid';
import {HoistModel, managed} from '@xh/hoist/core';
import {Icon} from '@xh/hoist/icon';
import {action, observable} from '@xh/hoist/mobx';
import {getIndicator, getIndicators} from './TechnicalIndicators';
import {dnaIcon, waveSineIcon} from '../../../../core/Icons';

export class IndicatorPickerModel extends HoistModel {
    @observable accessor isOpen: boolean = false;
    @managed indicatorGrid = this.createGridModel();

    @action
    open() {
        this.indicatorGrid.selectAsync(this.componentProps.indicatorValue);
        this.isOpen = true;
    }

    @action
    close() {
        this.isOpen = false;
    }

    @action
    select(value: string) {
        this.isOpen = false;

        if (this.componentProps.onValueChange) {
            this.componentProps.onValueChange(value);
        }
    }

    get indicatorDescription(): string {
        return getIndicator(this.componentProps.indicatorValue)?.label;
    }

    private createGridModel(): GridModel {
        const gridModel = new GridModel({
            hideHeaders: true,
            emptyText: 'No indicators',
            store: {
                idSpec: 'value'
            },
            autosizeOptions: {
                mode: 'onDemand'
            },
            onRowClicked: ({data}) => {
                this.select(data.data.value);
            },
            showHover: true,
            columns: [
                {
                    field: 'value',
                    width: 40,
                    renderer: (v, {record}) => {
                        return this.getIndicatorIcon(record.data.panel);
                    }
                },
                {
                    field: 'label',
                    flex: true
                },
                {
                    field: 'panel',
                    hidden: true
                }
            ],
            contextMenu: null
        });

        gridModel.loadData(getIndicators());

        return gridModel;
    }

    private getIndicatorIcon(type: string) {
        if (type === 'overlay') return waveSineIcon();
        else if (type === 'oscillator') return dnaIcon({rotation: 90});
        return Icon.placeholder();
    }
}
